// web worker root script
import * as t from './types'
import * as r from './registry'

onmessage = (e: MessageEvent) => {
  try {
    handleMessageFromClientToWorker(e);
  } catch (ex) {
    console.error('worker caught error:', ex);
  }
};

async function handleMessageFromClientToWorker(
  e: MessageEvent
): Promise<void> {
  const tm = JSON.parse(e.data) as t.TaskCreationRequest;

  const uuid = tm.uuid;
  const action = +tm.action as t.WorkerAction;
  const serializedParameters: string = tm.serializedParameters;
  const executor: t.TaskHandler | undefined = r.getService(action)!;

  try {
    if (!executor) {
      throw new Error(`Unknown WorkerAction: ${action}`);
    }

    console.log(`got workerAction ${action} aka ${t.WorkerAction[action]} ${uuid}.`);

    const serializedResult = await executor!({
      serializedParameters,
      reportProgress: function (progress: number) {
        postMessage(JSON.stringify({
          uuid,
          status: t.TaskStatus.Progressing,
          serializedResult: '',
          progress,
          excuse: '',
        } as t.TaskResponseMessage));
      },
    } as t.TaskInput);

    postMessage(JSON.stringify({
      uuid,
      status: t.TaskStatus.Complete,
      serializedResult,
      progress: 1.0,
      excuse: '',
    } as t.TaskResponseMessage));

    console.log(`workerAction ${action} aka ${t.WorkerAction[action]} ${uuid} responding.`);
  } catch (ex) {
    const excuse = JSON.stringify(
      ex,
      // Replacer...
      (_key, value) => {
        if (value?.constructor.name.includes('Error')) {
          return {
            name: value.name,
            message: value.message,
            stack: value.stack,
            cause: value.cause,
          };
        }

        return value;
      }
    );

    postMessage(JSON.stringify({
      uuid,
      status: t.TaskStatus.Failed,
      serializedResult: '',
      progress: 0.0,
      excuse,
    } as t.TaskResponseMessage));

    console.log(`workerAction ${action} aka ${t.WorkerAction[action]} ${uuid} failed.`);
  }
}